import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import Chip from "components/chip";
import styles from "./styles/selected-element.css.js";

const SelectedElement = ({ classes, elements, value, getValueFromElement, getLabelFromElement }) => {
  const val = typeof value === "object" ? getValueFromElement(value) : value;
  const element = elements?.find(element => getValueFromElement(element) === val);
  return element ? (
    <Chip key={getValueFromElement(element)} label={getLabelFromElement(element)} className={classes.chip} />
  ) : null;
};

SelectedElement.propTypes = {
  /**
   * Valor actual del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  /**
   * Función que obtiene el valor de la opción a partir de un elemento
   */
  getValueFromElement: PropTypes.func.isRequired,
  /**
   * Función que obtiene el valor de la etiqueta a partir de un elemento
   */
  getLabelFromElement: PropTypes.func.isRequired,
  /**
   * Colección de elementos del selector
   */
  elements: PropTypes.array.isRequired,
};

export default withStyles(styles)(SelectedElement);
